module.exports = __webpack_public_path__ + "static/media/partner_dapper.ffe6ae82.png";